import React from 'react';

import { FlyGlobalDialog } from '@fly/shared-ui';
import { type DialogState, useAppDispatch } from '@fly/store';
import { closeDialog } from '@fly/store';
import classNames from 'classnames';

interface DashboardLayoutProps {
  header: React.ReactNode;
  sidebar: React.ReactNode;
  content: React.ReactNode;
  chat?: React.ReactNode;
  dialog: DialogState;
  className?: string;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  header,
  sidebar,
  content,
  chat,
  dialog,
  className,
}) => {
  const dispatch = useAppDispatch();
  const close = () => {
    dispatch(closeDialog());
  };
  return (
    <div className={classNames('w-full', 'h-full', 'flex', className)}>
      {header}
      {sidebar}
      <div className='dashboard-container mt-[56px] mr-fly-5 mb-fly-5 flex w-full overflow-x-auto'>
        {content}
        {chat}
      </div>
      <FlyGlobalDialog
        isOpen={dialog.isOpen}
        width={dialog.width}
        title={dialog.title}
        description={dialog.description}
        content={dialog.content}
        showCloseDialog={dialog.showCloseDialog}
        close={close}
        data-testid={dialog?.['data-testid'] || 'global-dialog'}
      />
    </div>
  );
};
